import React from "react";

const STATUS_COLORS = {
  DRAFT: { bg: "bg-slate-500/15", text: "text-slate-300", border: "border-slate-500/30", dot: "bg-slate-400" },
  GENERATED: { bg: "bg-sky-500/15", text: "text-sky-300", border: "border-sky-500/30", dot: "bg-sky-400" },
  ACTIVE: { bg: "bg-emerald-500/15", text: "text-emerald-300", border: "border-emerald-500/30", dot: "bg-emerald-400" },
  ARCHIVED: { bg: "bg-neutral-500/15", text: "text-neutral-300", border: "border-neutral-500/30", dot: "bg-neutral-400" },
  FAILED: { bg: "bg-rose-500/15", text: "text-rose-300", border: "border-rose-500/30", dot: "bg-rose-400" },
};

const ENV_COLORS = {
  PRODUCTION: { bg: "bg-emerald-500/10", text: "text-emerald-300", border: "border-emerald-500/30" },
  DEVELOPMENT: { bg: "bg-sky-500/10", text: "text-sky-300", border: "border-sky-500/30" },
};

export function EnvStatusBadge({ status, size = "md" }) {
  const c = STATUS_COLORS[status] || STATUS_COLORS.DRAFT;
  const sizeCls = size === "sm" ? "text-[10px] px-2 py-0.5" : "text-xs px-2.5 py-1";
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full border font-black uppercase tracking-wider ${sizeCls} ${c.bg} ${c.text} ${c.border}`}
      data-testid={`env-status-${status.toLowerCase()}`}
    >
      <span className={`w-1.5 h-1.5 rounded-full ${c.dot}`} />
      {status}
    </span>
  );
}

export function EnvTypeBadge({ environment, size = "md" }) {
  const c = ENV_COLORS[environment] || { bg: "bg-white/5", text: "text-white/70", border: "border-white/10" };
  const sizeCls = size === "sm" ? "text-[10px] px-2 py-0.5" : "text-xs px-2.5 py-1";
  return (
    <span
      className={`inline-flex items-center rounded-full border font-bold ${sizeCls} ${c.bg} ${c.text} ${c.border}`}
      data-testid={`env-type-${environment?.toLowerCase()}`}
    >
      {environment}
    </span>
  );
}
